import { TextField, TextFieldProps } from "@mui/material";
import MenuItem from "@mui/material/MenuItem";
import { styled } from "@mui/material/styles";

const CustomizedTextField = styled(TextField)<TextFieldProps>(() => ({
  "& .MuiOutlinedInput-root": {
    paddingRight: 6,
    color: "#454545",
    borderRadius: 8,
    borderColor: "#454545",
    "&:hover .MuiOutlinedInput-notchedOutline": {
      borderColor: "#5D26C5",
      borderWidth: 2,
    },
    "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
      borderColor: "#5D26C5",
      borderWidth: 2,
    },

    "&.Mui-disabled": {
      color: "#191C1D",
      opacity: 0.38,
      borderColor: "rgba(25, 28, 29, 0.12)",
    },
  },
  "& .MuiFormLabel-root": {
    "&.Mui-focused": {
      color: "#5D26C5",
      fontWeight: 400,
    },
  },
}));

interface data {
  value: string;
  label?: string;
}

interface Props {
  documentTypes: data[];
  label?: string;
  value?: string;
  error?: boolean;
  helperText?: React.ReactNode;
  disabled?: boolean;
  placeholder?: string;
  maxLength?: number;
  minLength?: number;
  onClickClear?: React.MouseEventHandler<HTMLButtonElement> | (() => void);
  clear?: boolean;
  onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void;
  id?: string;
  testId?: string;
  name?: string;
  endAdornament?: React.ReactNode;
  fullWidth?: boolean;
  type?: string;
  onBlur?: React.FocusEventHandler<HTMLInputElement | HTMLTextAreaElement>;
  onFocus?: React.FocusEventHandler<HTMLInputElement | HTMLTextAreaElement>;
  autoComplete?: "off" | "on" | string;
  className?: string;
  style?: object;
  defaultValue?: string;
}

export const CustomInputSelect = (props: Props) => {
  const {
    documentTypes,
    label,
    error,
    helperText,
    disabled,
    placeholder,
    onChange,
    value,
    name,
    fullWidth,
    autoComplete,
    onBlur,
    onFocus,
    type,
    className,
    style,
    defaultValue,
  } = props;

  return (
    <CustomizedTextField
      id="outlined-select-document-type"
      select
      label={label}
      error={error}
      helperText={helperText}
      disabled={disabled}
      placeholder={placeholder}
      onChange={onChange}
      value={value}
      name={name}
      onBlur={onBlur}
      onFocus={onFocus}
      fullWidth={fullWidth}
      autoComplete={autoComplete}
      className={className}
      type={type}
      style={style}
      defaultValue={defaultValue}
    >
      {documentTypes.map((option) => (
        <MenuItem key={option.value} value={option.value}>
          {option.label || option.value}
        </MenuItem>
      ))}
    </CustomizedTextField>
  );
};
